import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from '../common/DatePicker/DatePicker';
import "./CommercialUnit.css";
import { FormError, getFormErrorByName, getFormErrorMessageByName, hasError, useFormErrorContext } from '../../utils/context/FormErrorContext';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';

interface StepDateProps {
    formData: Record<string, unknown>,
    handleDateChange: (date: Date | null | undefined, name: string) => void,
    handleCurrencyChange: (value: number | null, name: string) => void,
    currencySymbol?: string,
    excludeTBody?: boolean,
    colspan?: number,
    errors: FormError[],
    headers?: string[];
    disabled?: boolean;
}

export default function StepDate(props: StepDateProps): JSX.Element {
    const { t } = useTranslation('unit');
    const { removeError } = useFormErrorContext()


    const content = [];
    for (let i = 1; i <= 4; i++) {
        const dateFieldName = "stepUpDate" + i;
        const currencyFieldName = "stepUpRate" + i;
        const dateClassName = hasError(props.errors, dateFieldName) ? "table-error" : ""
        const currencyClassName = hasError(props.errors, currencyFieldName) ? "currency-input-td table-error" : "currency-input-td"
        content.push(
            <tr key={i}>
                <td colSpan={props.colspan} headers={(props.headers && props.headers.length > 0) ? props.headers[0] : undefined}>
                    <DatePicker name={dateFieldName} id={dateFieldName}
                        className={dateClassName}
                        date={props.formData[dateFieldName] as string | undefined}
                        onChange={(date, name) => {
                            props.handleDateChange(date, name)
                            removeError(getFormErrorByName(props.errors, dateFieldName)?.primaryKey as string)
                        }}
                        position='left'
                        errorMessage={getFormErrorMessageByName(props.errors, dateFieldName)}
                        // placeholderText={t('headings.step-date' + i + '-placeholder')}
                        title={t('headings.step-date' + i + '-placeholder')}
                        disabled={props.disabled}
                    />
                </td>
                <td className={currencyClassName} colSpan={props.colspan} headers={(props.headers && props.headers.length > 1) ? props.headers[1] : undefined}>
                    <AIRPNumberInput 
                        name={currencyFieldName}
                        symbol='$'
                        placeholder={"(" + props.currencySymbol + ")"}
                        textAlign='right'
                        initialValue={props.formData[currencyFieldName] as string}
                        onChange={(value: number | null) => props.handleCurrencyChange(value, currencyFieldName)}
                        tooltip={t('tooltips.step-rent-tooltip') + "(" + props.currencySymbol + ")"}
                    />
                </td>
            </tr>
        );
    }

    return props.excludeTBody ?  <>{content}</> : <tbody>{content}</tbody>    
        
   
}
